var EnumSerialiser = require('serialisers/enum-converter');

var State = {
    init : 0,
    active : 1,
    closed : 2,
    standby : 3
};

module.exports = {
    read : function(input) {
        return EnumSerialiser.read(input, State);
    },
    write : function(output, req) {
        EnumSerialiser.write(output, req, State);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/topic-update/update-source-state-serialiser.js
// module id = 499
// module chunks = 1